import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import Printicon from '@mui/icons-material/Print';
import MenuItem from '@mui/material/MenuItem';
import {
// Box,
// Tab,
} from '@mui/material';
import {
// TabContext,
// TabList,
// TabPanel,
} from '@mui/lab';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';

import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
// import {renderTextField, renderSelect} from '../../../atoms/CustomPart.js';
import {renderSelect} from '../../../atoms/CustomPart.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
// import DangerButton from '../../..//atoms/Buttons/DangerButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
// import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
// import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.SURVEY_POPULATION_LIST.name, href: ''},
];


const styles = (theme) => ({
  button: {
    margin: '15px 10px 5px 10px',
  },
  wave: {
    // fontSize: '1.2em',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%,-50%)',
  },
  fields: {
    'margin': '0px 10px 15px 10px',
  },
  textFieldDate: {
    margin: '0px 10px 15px 10px',
    width: '42%',
    minWidth: '100px',
  },
  tabPanel: {
    padding: 0,
  },
});

// 調査口数一覧
const populationViews = [
  {binding: 'zigyoujo', header: '旧NW事業所', type: 'text', width: 90, readOnly: true},
  // {binding: 'chousaYear', header: '次回調査年度', type: 'text', width: 100, readOnly: true},
  {binding: 'chousaCompany', header: '委託エリア', type: 'text', width: 100, readOnly: true},
  {header: '４年周期', dataType: 'header', elems: [
    {binding: 'keiSyu', header: '定額', dataType: 'String', width: 100, readOnly: true},
    {binding: 'keiSyuOther', header: '定額以外', dataType: 'String', width: 100, readOnly: false},
  ]},

  {header: '毎年調査', dataType: 'header', elems: [
    {binding: 'chousaIndustry2', header: '寝老人', dataType: 'String', width: 90, readOnly: true},
    {binding: 'chousaIndustry3', header: 'プール', dataType: 'String', width: 90, readOnly: false},
    {binding: 'chousaIndustry4', header: '公衆浴場', dataType: 'String', width: 90, readOnly: false},
    {binding: 'chousaIndustry5', header: '学校等', dataType: 'String', width: 90, readOnly: false},
    {binding: 'chousaIndustry6', header: '病院等', dataType: 'String', width: 90, readOnly: false},
    {binding: 'chousaIndustry7', header: '老人福祉施設', dataType: 'String', width: 100, readOnly: false},
    {binding: 'chousaIndustry8', header: '重要文化財', dataType: 'String', width: 100, readOnly: false},
    {binding: 'chousaIndustry9', header: '学校・プール', dataType: 'String', width: 100, readOnly: false},
    {binding: 'syouKei', header: '小計', dataType: 'String', width: 90, readOnly: false},
  ]},
  {binding: 'souKei', header: '総計', dataType: 'String', width: 90, readOnly: false},
];

// 可否判定申込で使用する申込ステータスコード
// 作成中,可否判定受付中,強度計算中,可否判定中,可否判定済,本申込中,完結（期限切れ）,完結（取止め）,完結（申込済）
// const proprietyOrderStatus = ['00', '01', '02', '03', '04', '05', '91', '92', '93'];

/**
 * 調査理由入力票一覧画面
 * 画面ID:SCB1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      warningMessages: [],
    };

    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const data =[
      {zigyoujo: '広島北', chousaYear: '2025', kukakuBango: '00001', chousaCompany: '委託１', keiSyu: '100', keiSyuOther: '100', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      {zigyoujo: '広島北', chousaYear: '2026', kukakuBango: '00001', chousaCompany: '委託１', keiSyu: '100', keiSyuOther: '100', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      {zigyoujo: '広島北', chousaYear: '2027', kukakuBango: '00001', chousaCompany: '委託１', keiSyu: '100', keiSyuOther: '100', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      {zigyoujo: '広島北', chousaYear: '2028', kukakuBango: '00001', chousaCompany: '委託１', keiSyu: '100', keiSyuOther: '100', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      // {zigyoujo: '合計', chousaYear: '2025', kukakuBango: '00001', chousaCompany: '委託１', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      // {zigyoujo: '合計', chousaYear: '2026', kukakuBango: '00001', chousaCompany: '委託１', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      // {zigyoujo: '合計', chousaYear: '2027', kukakuBango: '00001', chousaCompany: '委託１', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      // {zigyoujo: '合計', chousaYear: '2028', kukakuBango: '00001', chousaCompany: '委託１', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},

    ];

    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    // try {
    //   const result = await this._searchOrder();
    //   if (!result) {
    //     return;
    //   }
    //   // 検索結果が0件の場合、エラーダイアログ表示
    //   if (!this.props.hasOwnProperty('orderList') ||
    //     !this.props.orderList ||
    //     this.props.orderList.length <= 0 ) {
    //     this.props.doShowMessage({
    //       message: 'CE0016',
    //     });
    //   }
    // } catch (error) {
    //   this.props.doShowMessage({
    //     message: 'TKSCS00001S',
    //     action: () => {
    //       this.props.history.push('/login');
    //     },
    //   });
    // }
    // this.gridRef = {}
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 表示ボタン押下時
   */
  doDisplayInfo = async () => {
    this.props.navigate(GMN_PATH.CUSTOMER_SECURITY_INFO);
  };

  /**
   * 帳票印刷
   */
  doPrint = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['調査口数一覧出力'],
      },
    });
  };


  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}/>;
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'none',
      filterOn: false,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {height: 'auto', maxHeight: 'auto', maxWidth: 'auto', width: 'auto', marginTop: '0px'},
      isReadOnly: true,
      isDisplayCount: true,
      checkedFunction: this.checkStateUpdate,
    };
    // return (
    //   <CustomFlexGrid ref={this.gridRef} {...props}>
    //     {populationViews}
    //   </CustomFlexGrid>
    // );
    // 一覧定義取得
    let viewElems = [];
    if (populationViews) {
      for (const view of populationViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              // viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          // viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }


    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="key1001CreateSen1" item>
          <PositiveButton
            id="btn1001CreateSen1"
            onClick={this.doPrint}
            variant="contained"
            startIcon={<GetAppIcon />}
            // size="large"
          >
            <span>調査口数一覧出力</span>
          </PositiveButton>
        </Grid>
      </Grid>
    );
  };
  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name="zigyoujo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              type="text"
              label="NW事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={6120}>{'山口'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujoOld" item xs={12} sm={2}>
            <Field
              id="zigyoujoOld"
              name="zigyoujoOld"
              // variant="standard"
              component={renderSelect}
              className="fields"
              type="text"
              label="旧NW事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={6120}>{'廿日市'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="chousaKaisha" item xs={12} sm={2}>
            <Field
              id="chousaKaisha"
              name="chousaKaisha"
              component={renderSelect}
              className="fields"
              type="text"
              label="委託エリア"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={0}>{'中電'}</MenuItem>
              <MenuItem value={1}>{'委託１'}</MenuItem>
              <MenuItem value={2}>{'委託２'}</MenuItem>
              <MenuItem value={3}>{'委託３'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <Grid key="keySCC1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent="right"
              alignItems="right"
              spacing={1}
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className={classes.button}
                  // size="large"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className={clsx(classes.button)}
                  // size="large"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid key="key1001List" item xs={12}>
              {this.renderTable()}
            </Grid>
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    // initialValues: {
    //   dntNo1: '123',
    //   dntNo2: '456',
    //   dntNo3: '789',
    //   hikikomiDnt: '123',
    //   keiyakuNo1: '',
    //   jigyousyo: '456',
    //   states: '2',
    // },
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
